export const CONTAINER_BLACK_FRIDAY_PROPS = {
  backgroundColor: 'custom',
  backgroundColorHex: '#000',
  spaceIn: 'm',
  spaceOut: '0',
} as const
